import { SvgNotes, Tooltip } from '@loomhq/lens';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { handleToggleTranscriptCreator } from 'creators/shareVideo';

import { selectHasEnded, selectHasStarted } from 'selectors/videoPlayer';

import TranscriptNewExperienceWrapper from './transcriptNewExperienceWrapper';
import CollapsibleSideButton from '../collapsible-side-button';
import NewExperienceTag from '../video-buttons/newExperienceTag';
import {
  FAILED,
  SHORT_DURATION,
  TRANSCRIPTION_STATUSES,
} from '../../../../../shared/constants/videoTranscript';

const TranscriptOverlayButton = ({ isCollapsed }) => {
  const dispatch = useDispatch();
  const userCanAccessTranscript = useSelector(
    state => state?.share_video?.userCanAccessTranscript
  );
  const activeTranscriptId = useSelector(
    state => state?.video_player?.video?.active_video_transcript_id
  );

  const transcriptStatus = useSelector(
    state => state?.share_video?.transcript_details?.transcription_status
  );

  const showTranscriptButton =
    activeTranscriptId &&
    userCanAccessTranscript &&
    TRANSCRIPTION_STATUSES.includes(transcriptStatus) &&
    transcriptStatus !== FAILED;

  const hasStarted = useSelector(selectHasStarted);
  const hasEnded = useSelector(selectHasEnded);

  if (showTranscriptButton && transcriptStatus === SHORT_DURATION) {
    return (
      <Tooltip content="Transcript not available" placement="leftCenter">
        <CollapsibleSideButton
          onClick={() => {
            // do nothing
          }}
          icon={<SvgNotes />}
          isCollapsed={isCollapsed}
        >
          <div>Transcript Beta (n)&lrm;</div>
        </CollapsibleSideButton>
      </Tooltip>
    );
  }

  return (
    showTranscriptButton && (
      <TranscriptNewExperienceWrapper>
        {/* TranscriptNewExperienceWrapper uses the Function As Child Component (FaCC) pattern */}
        {({ showNewExperience }) => (
          <NewExperienceTag
            showNewExperience={(!hasStarted || hasEnded) && showNewExperience}
          >
            <CollapsibleSideButton
              onClick={() => {
                dispatch(handleToggleTranscriptCreator());
              }}
              data-testid="toggle-transcript-button"
              icon={<SvgNotes />}
              isCollapsed={isCollapsed}
              showNewExperience={showNewExperience}
            >
              <div>Transcript Beta (n)&lrm;</div>
            </CollapsibleSideButton>
          </NewExperienceTag>
        )}
      </TranscriptNewExperienceWrapper>
    )
  );
};

export default TranscriptOverlayButton;
